import React from 'react';
import Button from "components/Button";
import {PlusIcon} from "@heroicons/react/solid";
import TriggerActionType from "types/TriggerActionType";
import {FieldArray, FieldArrayRenderProps} from "formik";
import ActionEditor, {ActionFormData} from "pages/Trigger/Form/ActionEditor";

// Types ----

type ActionManagerProps = {
  name: string
}

// Helpers ----

const newAction: ActionFormData = {
  action_type: TriggerActionType.UNKNOWN,
  name: '',
  order: 1
}

// Component ----

function ActionManager({name}: ActionManagerProps) {
  return (
    <FieldArray name={name}>
      {({push, remove, form}: FieldArrayRenderProps) => (
        <div>
          <ul>
            {form.values[name].map((action: ActionFormData, index: number) => (
              <li key={index} className="my-4">
                <ActionEditor
                  name={name}
                  index={index}
                  count={form.values[name].length}
                  form={form}
                  action={action}
                  onRemove={() => remove(index)}
                  onChange={actionData => form.setFieldValue(`${name}.${index}`, actionData)}
                />
              </li>
            ))}
          </ul>

          <div className="mt-4">
            <Button
              color={Button.colors.SECONDARY}
              icon={PlusIcon}
              onClick={() => push({...newAction, order: (form.values[name].length || 0) + 1})}>
              Add Action
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  );
}

// Export ----

export default ActionManager;